module.exports = __webpack_public_path__ + "img/Ekivolt_80X30.dd2d6232.png";